(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7144,2576,5124,949],{

/***/ 99904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _2022; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
;// CONCATENATED MODULE: ../../libs/templates/FooterBasic/FooterBasic.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eg57sqx0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FooterBasic/FooterBasic.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}











var FooterBasic = function FooterBasic(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var FooterBasic_FooterBasic = (FooterBasic);
;// CONCATENATED MODULE: ../../libs/templates/FooterBasic/index.ts

// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/RecommendedReading/RecommendedReading.tsx










var copy = {
  heading: "Recommended reading"
};
var data = [{
  title: "CDP Buyer\u2019s Guide",
  description: "Our buyer\u2019s guide for CDPs will help you understand when it\u2019s time to buy a CDP, which features you need, and how to evaluate the various CDP vendors out there.",
  href: "https://learn.segment.com/cdp-buying-guide/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_growth-report_"
}, {
  title: "Ultimate Guide to Customer Retention",
  description: "Learn how to avoid rising customer acquisition costs and increase customer engagement with proven retention strategies.",
  href: "https://learn.segment.com/the-ultimate-guide-to-customer-retention/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_growth-report_20220929&utm_content=ebook"
}, {
  title: "State of Personalization Report",
  description: "We surveyed businesses and consumers around the world to explore how attitudes, preferences, and experiences with personalization have evolved over the past year.",
  href: "/state-of-personalization-report/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_growth-report_"
}];

var RecommendedReading = function RecommendedReading() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Background, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: copy.heading
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 2,
            xl: 3
          },
          children: data.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              href: (0,getAbsoluteUrl/* default */.Z)(item.href, pageConfig),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    tag: "h3",
                    children: item.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    variant: "pLarge",
                    children: item.description
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, item.title);
          })
        })
      })]
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eaqpst61"
} : 0)(Section/* Wrapper */.im, "{row-gap:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:56px;}}" + ( true ? "" : 0));

var Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eaqpst60"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var RecommendedReading_RecommendedReading = (RecommendedReading);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/Methodology/Methodology.tsx


function Methodology_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Methodology_copy = {
  heading: "Methodology",
  description: ["Twilio Segment conducted this research using an online survey prepared by <a href=\"https://www.methodcommunications.com/methodresearch/\">Method Research</a> and distributed by <a href=\"https://www.cint.com/\">Cint</a> among n=1,300 full-time employees working in marketing and customer services roles at B2B companies with 75+ employees.", "The sample consisted of n=1,000 respondents from the United States and n=300 from the United Kingdom. Data was collected from August 3 to August 17, 2022."],
  disclaimer: " This report, The Growth Report, contains statistical data, estimates and expectations that are based on the above publicly available report. This data does not represent, and should not be construed as indicators of Twilio's historical or future financial performance or the actual or potential demand for Twilio's products and solutions, and such information is solely presented as context for broader market trends."
};

var Introduction = function Introduction() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverline, {
          variant: "overline",
          tag: "h2",
          children: Methodology_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
            overrides: {
              lg: 2
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
              children: Methodology_copy.description.map(function (text) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                    variant: "pMedium",
                    dangerouslySetInnerHTML: {
                      __html: sanitize_html_default()(text, {
                        allowedTags: ["a"]
                      })
                    }
                  })
                }, text);
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DisclaimerWrapper, {
              tag: "p",
              variant: "pMedium",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerTitle, {
                variant: "pMedium",
                tag: "span",
                children: "Disclaimer:"
              }), Methodology_copy.disclaimer]
            })]
          })
        })]
      })
    })
  });
};

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebmk25l6"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var StyledOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "ebmk25l5"
} : 0)("color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.segmentGreen[500];
}, ";" + ( true ? "" : 0));

var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "ebmk25l4"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-left:20px;}margin:0;" + ( true ? "" : 0));

var DisclaimerTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ebmk25l3"
} : 0)("font-weight:600;font-style:italic;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.brand.darkAcai[500];
}, ";" + ( true ? "" : 0));

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ebmk25l2"
} : 0)("padding-left:24px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-right:30px;}" + ( true ? "" : 0));

var Li = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ebmk25l1"
} : 0)( true ? {
  name: "4yl35v",
  styles: ":not(:first-of-type){margin:28px auto;}:last-of-type{margin-bottom:0;}"
} : 0);

var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ebmk25l0"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

/* harmony default export */ var Methodology = (Introduction);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(6504);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(78159);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(46323);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Hero_copy = {
  title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "The Growth Report\xA02022"
  }),
  description: "Brought to you by Twilio Segment"
};
var Hero_form = {
  customFormIdentifier: "growth-report-2022",
  additionalTrackEvent: "Content Downloaded",
  buttonText: "Download the Growth Report",
  buttonUrl: "https://segment.com/pdfs/Twilio-Segment-Growth-Report-2022.pdf",
  overrideConsent: true
};

var Hero = function Hero() {
  var _useState = (0,react.useState)(false),
      isSubmitted = _useState[0],
      setIsSubmitted = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundPattern, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: Hero_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: Hero_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
          variant: isSubmitted ? "wide" : "narrow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            resourceType: "report",
            customFormIdentifier: Hero_form.customFormIdentifier,
            additionalTrackEvent: Hero_form.additionalTrackEvent,
            overrideConsent: Hero_form.overrideConsent,
            buttonText: Hero_form.buttonText,
            successButtonText: Hero_form.buttonText,
            buttonUrl: Hero_form.buttonUrl,
            onSubmit: function onSubmit() {
              return setIsSubmitted(true);
            },
            enableJobTitleField: true
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            src: (Hero_2x_default()),
            width: "460",
            height: "460",
            alt: "Illustration: The Growth Report"
          })]
        })
      })]
    })]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e17xgz343"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.segmentGreen[100];
}, ";position:relative;" + ( true ? "" : 0));

var BackgroundPattern = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xgz342"
} : 0)("position:absolute;top:0;right:0;bottom:0;left:0;background-image:radial-gradient(", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.brand.segmentGreen[400];
}, " 1px, transparent 0);mask-image:linear-gradient(to right, transparent 20%, black);background-size:18px 18px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{background-image:radial-gradient(", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.brand.segmentGreen[400];
}, " 2px, transparent 0);background-size:36px 36px;}" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e17xgz341"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xgz340"
} : 0)("max-width:", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "narrow" ? "417px" : "unset";
}, ";margin-top:38px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{margin-top:48px;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Introduction/assets/Introduction@2x.png
var Introduction_2x = __webpack_require__(44326);
var Introduction_2x_default = /*#__PURE__*/__webpack_require__.n(Introduction_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Introduction/assets/Introduction.webp
var assets_Introduction = __webpack_require__(3782);
var Introduction_default = /*#__PURE__*/__webpack_require__.n(assets_Introduction);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/Introduction/assets/Introduction@2x.webp
var assets_Introduction_2x = __webpack_require__(36351);
var assets_Introduction_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Introduction_2x);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/Introduction/Introduction.tsx


function Introduction_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var description = ["Over the past 10 years, the \"growth at all costs\" mindset has been the norm. Build, build more, build better, build at all costs. Just get growing.", "Today, business growth looks dramatically different. With a variety of factors at play, from a tumultuous global economy to businesses shifting how and where they work, the growth over all else mindset is officially over. In its place is a more strategic, calculated shift to growth, where businesses are doubling down on sustainable paths to growth, such as long-term customer loyalty, and profitability.", "In our annual Growth Report, Twilio Segment surveyed leaders from across industries about what this shift means for the future of doing business. Here are our top takeaways about what growing as a business means today."];

var Introduction_Introduction = function Introduction() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: description.map(function (item, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
            tag: "p",
            children: item
          }, index);
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((Introduction_default()), ", ").concat((assets_Introduction_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: (Introduction_2x_default()),
          width: "520",
          height: "659",
          alt: "Illustration: Introduction"
        })]
      })
    })]
  });
};

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "ewj40o00"
} : 0)( true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0);

/* harmony default export */ var components_Introduction_Introduction = (Introduction_Introduction);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/ItemSection.tsx


function ItemSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var ItemSection = function ItemSection(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      images = _ref.images;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: sanitize_html_default()(heading)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: images === null || images === void 0 ? void 0 : images.map(function (_ref2, index) {
        var src2x = _ref2.src2x,
            webp = _ref2.webp,
            webp2x = _ref2.webp2x,
            mobile = _ref2.mobile,
            height = _ref2.height,
            width = _ref2.width,
            alt = _ref2.alt;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [mobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              media: theme.breakpoints.down("md", false),
              srcSet: "".concat(mobile.src, ", ").concat(mobile.src2x, " 2x")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              media: theme.breakpoints.down("md", false),
              type: "image/webp",
              srcSet: "".concat(mobile.webp, ", ").concat(mobile.webp2x, " 2x")
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat(webp, ", ").concat(webp2x, " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
            width: width,
            height: height,
            src: src2x,
            alt: alt || "",
            loading: "lazy"
          })]
        }, index);
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ergvhgp2"
} : 0)(Section/* Wrapper */.im, "{justify-content:unset;margin:0;padding:40px 0;row-gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{row-gap:40px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{column-gap:80px;}}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ergvhgp1"
} : 0)( true ? {
  name: "16tak5u",
  styles: "height:100%;display:flex;flex-direction:column;justify-content:start"
} : 0);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ergvhgp0"
} : 0)( true ? {
  name: "139a66z",
  styles: "justify-items:start;display:grid;gap:16px"
} : 0);

/* harmony default export */ var KeyFindings_ItemSection = (ItemSection);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame@2x.png
var Frame_2x = __webpack_require__(9109);
var Frame_2x_default = /*#__PURE__*/__webpack_require__.n(Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame.webp
var Frame = __webpack_require__(69228);
var Frame_default = /*#__PURE__*/__webpack_require__.n(Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame@2x.webp
var section1_Frame_2x = __webpack_require__(78434);
var section1_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section1_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame2@2x.png
var Frame2_2x = __webpack_require__(6586);
var Frame2_2x_default = /*#__PURE__*/__webpack_require__.n(Frame2_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame2.webp
var Frame2 = __webpack_require__(56125);
var Frame2_default = /*#__PURE__*/__webpack_require__.n(Frame2);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section1/Frame2@2x.webp
var section1_Frame2_2x = __webpack_require__(82634);
var section1_Frame2_2x_default = /*#__PURE__*/__webpack_require__.n(section1_Frame2_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section2/Frame@2x.png
var section2_Frame_2x = __webpack_require__(83873);
var section2_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section2_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section2/Frame.webp
var section2_Frame = __webpack_require__(5869);
var section2_Frame_default = /*#__PURE__*/__webpack_require__.n(section2_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section2/Frame@2x.webp
var assets_section2_Frame_2x = __webpack_require__(68862);
var assets_section2_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section2_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section3/Frame@2x.png
var section3_Frame_2x = __webpack_require__(26460);
var section3_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section3_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section3/Frame.webp
var section3_Frame = __webpack_require__(45489);
var section3_Frame_default = /*#__PURE__*/__webpack_require__.n(section3_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section3/Frame@2x.webp
var assets_section3_Frame_2x = __webpack_require__(62782);
var assets_section3_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section3_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section4/Frame@2x.png
var section4_Frame_2x = __webpack_require__(71106);
var section4_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section4_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section4/Frame.webp
var section4_Frame = __webpack_require__(4916);
var section4_Frame_default = /*#__PURE__*/__webpack_require__.n(section4_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section4/Frame@2x.webp
var assets_section4_Frame_2x = __webpack_require__(84506);
var assets_section4_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section4_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section5/Frame@2x.png
var section5_Frame_2x = __webpack_require__(47557);
var section5_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section5_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section5/Frame.webp
var section5_Frame = __webpack_require__(36447);
var section5_Frame_default = /*#__PURE__*/__webpack_require__.n(section5_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section5/Frame@2x.webp
var assets_section5_Frame_2x = __webpack_require__(17911);
var assets_section5_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section5_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section6/Frame@2x.png
var section6_Frame_2x = __webpack_require__(30978);
var section6_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section6_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section6/Frame.webp
var section6_Frame = __webpack_require__(92616);
var section6_Frame_default = /*#__PURE__*/__webpack_require__.n(section6_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section6/Frame@2x.webp
var assets_section6_Frame_2x = __webpack_require__(84330);
var assets_section6_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section6_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/Frame@2x.png
var section7_Frame_2x = __webpack_require__(47808);
var section7_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(section7_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/Frame.webp
var section7_Frame = __webpack_require__(13542);
var section7_Frame_default = /*#__PURE__*/__webpack_require__.n(section7_Frame);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/Frame@2x.webp
var assets_section7_Frame_2x = __webpack_require__(5353);
var assets_section7_Frame_2x_default = /*#__PURE__*/__webpack_require__.n(assets_section7_Frame_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/FrameMobile.png
var FrameMobile = __webpack_require__(11396);
var FrameMobile_default = /*#__PURE__*/__webpack_require__.n(FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/FrameMobile@2x.png
var FrameMobile_2x = __webpack_require__(19012);
var FrameMobile_2x_default = /*#__PURE__*/__webpack_require__.n(FrameMobile_2x);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/FrameMobile.webp
var section7_FrameMobile = __webpack_require__(14900);
var section7_FrameMobile_default = /*#__PURE__*/__webpack_require__.n(section7_FrameMobile);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/assets/section7/FrameMobile@2x.webp
var section7_FrameMobile_2x = __webpack_require__(98986);
var section7_FrameMobile_2x_default = /*#__PURE__*/__webpack_require__.n(section7_FrameMobile_2x);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/data.tsx
/** Section 1 */






/* Section 2 */




/* Section 3 */




/* Section 4 */




/* Section 5 */




/* Section 6 */




/* Section 7 */








var items = [{
  key: 0,
  heading: "The \u201Cgrowth-at-all-costs\u201D era is&nbsp;over ",
  description: "Buckle up. With volatility in the global economy, companies have realized that a growth-at-all-costs mindset is neither efficient nor scalable, and have refocused their workforce, budgets, and business strategy around efficiency.",
  images: [{
    src2x: (Frame_2x_default()),
    webp: (Frame_default()),
    webp2x: (section1_Frame_2x_default()),
    height: 280,
    width: 640,
    alt: "61% of respondents reporting that the \u201Cgrowth-at-all-costs\u201D mentality is over."
  }, {
    src2x: (Frame2_2x_default()),
    webp: (Frame2_default()),
    webp2x: (section1_Frame2_2x_default()),
    height: 280,
    width: 640,
    alt: "93% of businesses are taking steps to plan for a recession."
  }]
}, {
  key: 1,
  heading: "Efficiency and profitability are the new north stars",
  description: "Say goodbye to the bells and whistles of the growth era. Companies are now leaning into their bottom line by focusing on what works today to support any volatility tomorrow.",
  images: [{
    src2x: (section2_Frame_2x_default()),
    webp: (section2_Frame_default()),
    webp2x: (assets_section2_Frame_2x_default()),
    height: 300,
    width: 640,
    alt: "62% of respondents say their business has increased their focus on profitability over the past 12 months."
  }]
}, {
  key: 2,
  heading: "Marketing budgets are declining",
  description: "As business budgets decline, marketing departments will need to be thoughtful and creative about what technology they use and how they maximize existing budgets for new campaigns.",
  images: [{
    src2x: (section3_Frame_2x_default()),
    webp: (section3_Frame_default()),
    webp2x: (assets_section3_Frame_2x_default()),
    height: 300,
    width: 640,
    alt: "Over half (57%) of respondents say their company is currently spending money on ineffective tools that they don\u2019t need."
  }]
}, {
  key: 3,
  heading: "A wave of consolidation is coming",
  description: "Is this product really delivering ROI? Can we maximize success with technology that delivers on multiple business goals? As businesses begin to streamline their technology adoption, these are the hard questions companies are asking themselves.",
  images: [{
    src2x: (section4_Frame_2x_default()),
    webp: (section4_Frame_default()),
    webp2x: (assets_section4_Frame_2x_default()),
    height: 300,
    width: 640,
    alt: "83% of respondents plan to simplify their marketing tech stack within the next 12 months."
  }]
}, {
  key: 4,
  heading: "Businesses are doubling down on what works",
  description: "While some experimentation is still happening, most businesses are leaning into tried and true channels like email to grow revenue.",
  images: [{
    src2x: (section5_Frame_2x_default()),
    webp: (section5_Frame_default()),
    webp2x: (assets_section5_Frame_2x_default()),
    height: 300,
    width: 640,
    alt: "69% of businesses say they are leaning into channels with proven ROI."
  }]
}, {
  key: 5,
  heading: "Data is the next frontier of business growth",
  description: "So how can businesses continue to grow amid a turbulent market? By leaning into technology that helps them understand buyer behavior, improve marketing performance, and deliver hyper-personalized experiences.",
  images: [{
    src2x: (section6_Frame_2x_default()),
    webp: (section6_Frame_default()),
    webp2x: (assets_section6_Frame_2x_default()),
    height: 300,
    width: 640,
    alt: "71% of businesses are prioritizing capturing and leveraging first-party data better."
  }]
}, {
  key: 6,
  heading: "Customer data platforms will be how businesses get there",
  description: "As customer engagement continues to be paramount to business success, investing in technology that both collects and analyzes customer data will be essential in helping businesses continue to grow.",
  images: [{
    src2x: (section7_Frame_2x_default()),
    webp: (section7_Frame_default()),
    webp2x: (assets_section7_Frame_2x_default()),
    mobile: {
      src: (FrameMobile_default()),
      src2x: (FrameMobile_2x_default()),
      webp: (section7_FrameMobile_default()),
      webp2x: (section7_FrameMobile_2x_default())
    },
    height: 240,
    width: 640,
    alt: "Businesses who are using CDPs report almost 2x higher customer satisfaction levels than those without a CDP."
  }]
}];
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/components/KeyFindings/KeyFindings.tsx



var KeyFindings_excluded = ["key"];

function KeyFindings_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function KeyFindings_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? KeyFindings_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : KeyFindings_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function KeyFindings_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var KeyFindings_copy = {
  heading: "Key findings"
};

var KeyFindings = function KeyFindings() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KeyFindings_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KeyFindings_StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: KeyFindings_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: items.map(function (_ref) {
        var key = _ref.key,
            itemProps = (0,objectWithoutProperties/* default */.Z)(_ref, KeyFindings_excluded);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_ItemSection, KeyFindings_objectSpread({}, itemProps)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
        }, key);
      })
    })]
  });
};

var StyledCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e1mnol873"
} : 0)("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.brand.segmentGreen[500];
}, ";" + ( true ? "" : 0));

var KeyFindings_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1mnol872"
} : 0)(">", Section/* Wrapper */.im, "{row-gap:0;justify-content:unset;margin:0;padding-bottom:0;}" + ( true ? "" : 0));

var KeyFindings_StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1mnol871"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1mnol870"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

/* harmony default export */ var KeyFindings_KeyFindings = (KeyFindings);
// EXTERNAL MODULE: ./src/views/TheGrowthReport2022/assets/OgGrowthReport.jpg
var OgGrowthReport = __webpack_require__(14386);
var OgGrowthReport_default = /*#__PURE__*/__webpack_require__.n(OgGrowthReport);
;// CONCATENATED MODULE: ./src/views/TheGrowthReport2022/TheGrowthReport.tsx
















var TheGrowthReportView = function TheGrowthReportView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TheGrowthReport_Background, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
        pageTitle: "The Growth Report by Twilio Segment",
        pageDescription: "How customer data fuels high-performance growth organizations",
        pageOG: (OgGrowthReport_default()),
        themeColor: theme.palette.brand.darkAcai[700],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Introduction_Introduction, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindings, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_RecommendedReading, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBasic_FooterBasic, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1xvt6ze1"
} : 0)( true ? "" : 0);

var TheGrowthReport_Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xvt6ze0"
} : 0)("display:grid;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var TheGrowthReport2022_TheGrowthReport = (TheGrowthReportView);
;// CONCATENATED MODULE: ./src/pages/the-growth-report/2022/index.tsx



var TheGrowthReport = function TheGrowthReport() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheGrowthReport2022_TheGrowthReport, {});
};

/* harmony default export */ var _2022 = (TheGrowthReport);

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 16164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paper_Paper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etxif140"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";border-radius:", function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return borderRadius;
}, "px;border:", function (_ref3) {
  var border = _ref3.border;
  return border;
}, ";width:100%;height:100%;box-shadow:", function (_ref4) {
  var theme = _ref4.theme,
      elevation = _ref4.elevation;
  return theme.shadows[elevation];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.tsx


var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Paper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/index.ts


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx







var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 4493:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-growth-report/2022",
      function () {
        return __webpack_require__(99904);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14386:
/***/ (function(module) {

module.exports = "/_next/static/images/OgGrowthReport-3ff845d26ffa654fcb9ae3e68701e301.jpg";

/***/ }),

/***/ 6504:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-82b34d8912217a8bf2f2eeb9ff488518.png";

/***/ }),

/***/ 44326:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction@2x-8118e3aeb6a746d203d1b2fa2e75d2e2.png";

/***/ }),

/***/ 6586:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2@2x-158e4c8a99d7f1466ff7d6d0b36594ab.png";

/***/ }),

/***/ 9109:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-d8f0acd6151c5252364e41dce5837789.png";

/***/ }),

/***/ 83873:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-c7615e68f8d72b7ff8163e04cae4deee.png";

/***/ }),

/***/ 26460:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-bffb45f247a5fd5f742a95fc93b31cc7.png";

/***/ }),

/***/ 71106:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-f1416492117cfe5743995eae1131e0e9.png";

/***/ }),

/***/ 47557:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-209115bc187d0b71e49dd24bc3282078.png";

/***/ }),

/***/ 30978:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-46efb844cd4aa9b4c08fcc793e47a567.png";

/***/ }),

/***/ 47808:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-e81c63c316fe038890832248e1348e4d.png";

/***/ }),

/***/ 11396:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-1c99a9f38dfed20fcb47300620dd4b90.png";

/***/ }),

/***/ 19012:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile@2x-5cb4fbdbd3fb0f2fe7d8c303092edd0f.png";

/***/ }),

/***/ 78159:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-10a34aa2f8017c47df4a9ce07049b644.webp";

/***/ }),

/***/ 46323:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-7d1a5c895270209a3cf5f484ca360459.webp";

/***/ }),

/***/ 3782:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction-56e12d4f62aae4b0915304eaf23de1d3.webp";

/***/ }),

/***/ 36351:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction@2x-1e1361e39efea6fa719ba67d3236a7ed.webp";

/***/ }),

/***/ 69228:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-2df42ddfd46a18d65a926a3415b193bd.webp";

/***/ }),

/***/ 56125:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2-e9dcbed11b08b8077e7045260c5f1303.webp";

/***/ }),

/***/ 82634:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame2@2x-92406ed86a4e4d70ffe8427cc2e1fa17.webp";

/***/ }),

/***/ 78434:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-098b503d13b46213c539c54b8a09c4dd.webp";

/***/ }),

/***/ 5869:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-2ddb5cf57418c649724f9dc17b1c6a4f.webp";

/***/ }),

/***/ 68862:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-122754ac075c2a20514230cee8a026a1.webp";

/***/ }),

/***/ 45489:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-258be4040cc78db63e86f6bacc3323fc.webp";

/***/ }),

/***/ 62782:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-496c272c6bf0aa31b9292ef5e67c36fa.webp";

/***/ }),

/***/ 4916:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-fce27ea86bb9f41bbef3542089a8901a.webp";

/***/ }),

/***/ 84506:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-ce1980312b28f0cf6c7a3f5c40652d46.webp";

/***/ }),

/***/ 36447:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-1351f54729d25438099d3fc81fc3bc7b.webp";

/***/ }),

/***/ 17911:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-7eaaf28ced9b02d8c2726c024c862e32.webp";

/***/ }),

/***/ 92616:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-453d98e2f5bb88d6ba012fdd1ad3421f.webp";

/***/ }),

/***/ 84330:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-0eaa908d07bc4388bd15ea8b4bf0988c.webp";

/***/ }),

/***/ 13542:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame-99bf2f6cd7adb35772702db0cae452e2.webp";

/***/ }),

/***/ 5353:
/***/ (function(module) {

module.exports = "/_next/static/images/Frame@2x-d8d23f2089da55a063f1fcd865d040b3.webp";

/***/ }),

/***/ 14900:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile-e80c5b0d723f309bc7ebe8e1acc91871.webp";

/***/ }),

/***/ 98986:
/***/ (function(module) {

module.exports = "/_next/static/images/FrameMobile@2x-04c1c415f2786d5ceb4e5532a2ff08bd.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3254,9129,8834,4330,1382,4136,8392,2073,7096,2429,4488,948,8187,3996,7947,7960,6012,442,4881,9774,2888,179], function() { return __webpack_exec__(4493); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);